import { ref } from 'vue';
import { useAuthenticatedFetch } from '../auth/useAuthenticatedFetch';
import { Announcement, AnnouncementRequest, AnnouncementSearchParams, AnnouncementDisplayParams } from '@/interfaces/announcement';
import { announcements, clubUUID, paginationLinks } from '@/shared/state';

const { authenticatedFetch } = useAuthenticatedFetch();
const API_URL = process.env.VUE_APP_ROOT_API;
export function useAnnouncement() {
    const errorAnnouncement = ref<boolean | false>(false);
    const isRequestAnnouncement = ref<boolean | false>(false);
    const getAnnouncements = async () => {
        try {
            isRequestAnnouncement.value = true
            errorAnnouncement.value = false
            const response = await authenticatedFetch(`${API_URL}announcements/${clubUUID.value}`, {
                method: 'GET'
            }, false, '', false);
            announcements.data = response?.announcements || []
            isRequestAnnouncement.value = false
        } catch (err: any) {
            errorAnnouncement.value = true
            isRequestAnnouncement.value = false

        }
    };

    const fetchAnnouncements = async (body: AnnouncementSearchParams) => {
        try {
            isRequestAnnouncement.value = true
            errorAnnouncement.value = false
            announcements.data = []
            paginationLinks.value = 0
            const response = await authenticatedFetch(`${API_URL}announcements/search`, {
                method: 'POST',
                body: JSON.stringify(body),
            }, false, '', false);
            if (response) {
                if (body?.type === 'paginate') {

                    announcements.data = response?.data || []
                    paginationLinks.value = response;
                    delete paginationLinks.value.data
                } else {
                    announcements.data = response?.data || {}

                }
                isRequestAnnouncement.value = false
            }
        } catch (err: any) {
            errorAnnouncement.value = true;
            isRequestAnnouncement.value = false
        }
    };
    const fetchDisplayAnnouncements = async (announcementsIDs, clubUUID) => {
        try {
            isRequestAnnouncement.value = true
            errorAnnouncement.value = false
            announcements.data = []
            const response = await authenticatedFetch(`${API_URL}announcements/display/${clubUUID}/${announcementsIDs}`, {
                method: 'GET',
            }, false, '', false);
            if (response) {
                announcements.data = response?.data || []
                isRequestAnnouncement.value = false
            }
        } catch (err: any) {
            errorAnnouncement.value = true;
            isRequestAnnouncement.value = false
        }
    };
    const addAnnouncement = async (body: AnnouncementRequest) => {
        try {
            isRequestAnnouncement.value = true
            errorAnnouncement.value = false
            const response = await authenticatedFetch(`${API_URL}announcements/store/${clubUUID.value}`, {
                method: 'POST',
                body: JSON.stringify(body),
            }, true, '', true);
            if (response?.data) {
                const announcementAdded: Announcement = response?.data
                announcements?.data?.unshift(announcementAdded)
                isRequestAnnouncement.value = false

            } else {
                errorAnnouncement.value = true
                isRequestAnnouncement.value = false

            }

        } catch (err: any) {
            errorAnnouncement.value = true;
            isRequestAnnouncement.value = false
        }
    };

    const editAnnouncement = async (body: AnnouncementRequest) => {
        try {
            isRequestAnnouncement.value = true
            errorAnnouncement.value = false
            const response = await authenticatedFetch(`${API_URL}announcements/edit/${body?.id}/${clubUUID.value}`, {
                method: 'PUT',
                body: JSON.stringify(body),
            }, true, '', true);
            if (response?.data) {
                const announcementEdited: Announcement = response?.data
                const index = announcements?.data?.findIndex(announcement => announcement?.id === announcementEdited?.id);
                if (index !== -1) {
                    announcements.data[index] = announcementEdited;
                }
                isRequestAnnouncement.value = false

            } else {
                errorAnnouncement.value = true
                isRequestAnnouncement.value = false

            }

        } catch (err: any) {
            errorAnnouncement.value = true;
            isRequestAnnouncement.value = false
        }
    };

    const deleteAnnouncement = async (id: number) => {
        try {
            isRequestAnnouncement.value = true
            errorAnnouncement.value = false
            const response = await authenticatedFetch(`${API_URL}announcements/delete/${id}/${clubUUID.value}`, {
                method: 'DELETE'
            }, true, '', true);
            const index = announcements?.data?.findIndex(announcement => announcement?.id === id);
            if (index !== -1) {
                announcements.data.splice(index, 1);
            }
            isRequestAnnouncement.value = false
        } catch (err: any) {
            errorAnnouncement.value = true;
            isRequestAnnouncement.value = false
        }
    };

    return {
        getAnnouncements,
        addAnnouncement,
        editAnnouncement,
        deleteAnnouncement,
        isRequestAnnouncement,
        fetchAnnouncements,
        fetchDisplayAnnouncements,
        errorAnnouncement
    };
}
